import Button from "backpack-ui/dist/components/button";
import Switch from "backpack-ui/dist/components/switch";
import Textarea from "backpack-ui/dist/components/textarea";
import * as React from "react";
import * as styles from "./styles.css";
export var BookmarkAddEditList = function (_a) {
    var disableSaveButton = _a.disableSaveButton, _b = _a.nameValue, nameValue = _b === void 0 ? "" : _b, privacyChecked = _a.privacyChecked, nameOnChange = _a.nameOnChange, onCancel = _a.onCancel, onSave = _a.onSave, privacyToggle = _a.privacyToggle;
    return (React.createElement("div", { className: styles.bookmarkAddEditListFieldset },
        React.createElement("div", null,
            React.createElement("label", { className: styles.bookmarkAddEditListLabel, htmlFor: "list-name" }, "List name"),
            React.createElement(Textarea, { id: "list-name", name: "list_name", placeholder: "List name", onChange: nameOnChange, value: nameValue, maxLines: 3, autofocus: true, autogrow: true })),
        React.createElement("div", { className: styles.bookmarkAddEditListField },
            React.createElement("div", { className: styles.bookmarkAddEditListLabel }, "Privacy"),
            React.createElement("div", { className: styles.bookmarkAddEditListSwitch },
                React.createElement("label", { htmlFor: "privacy-control" }, "Appears in your public profile"),
                React.createElement(Switch, { id: "privacy-control", name: "privacy_control", value: "private", checked: privacyChecked, onClick: privacyToggle }))),
        React.createElement("footer", { className: styles.bookmarkAddEditListFieldsetFooter },
            React.createElement(Button, { className: styles.bookmarkAddEditListSaveButtonDesktop, onClick: onCancel, color: "gray", rounded: true, border: true }, "Cancel"),
            React.createElement(Button, { className: styles.bookmarkAddEditListSaveButtonDesktop, onClick: onSave, disabled: disableSaveButton, rounded: true }, "Save"))));
};



//////////////////
// WEBPACK FOOTER
// ./app/shared/components/bookmark/bookmarkAddEditList.tsx
// module id = sueZ
// module chunks = 2